/* eslint-disable */

export interface HttpClient<Headers> {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: Headers; }): RestResponse<R>;
}

export class RestApplicationClient<Headers> {

    constructor(protected httpClient: HttpClient<Headers>) {
    }

    /**
     * HTTP POST /laaneramme
     * Java method: no.eika.kreditt.boliglaankalkulator.web.laaneramme.LaanerammeResource.getLaaneramme
     */
    getLaaneramme(arg0: LaanerammeWeb, options?: Headers): RestResponse<MaksLaanerammeWeb> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`laaneramme`, data: arg0, copyFn: __identity<MaksLaanerammeWeb>(), options: options });
    }

    /**
     * HTTP GET /laaneramme/markedsrente
     * Java method: no.eika.kreditt.boliglaankalkulator.web.laaneramme.LaanerammeResource.getMarkedsrente
     */
    getMarkedsrente(options?: Headers): RestResponse<RenteOgGebyrWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`laaneramme/markedsrente`, copyFn: __identity<RenteOgGebyrWeb>(), options: options });
    }

    /**
     * HTTP GET /liveness/health
     * Java method: no.eika.infrastruktur.jakarta.server.lib.HealthResource.liveness
     */
    liveness(options?: Headers): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`liveness/health`, copyFn: __identity<any>(), options: options });
    }

    /**
     * HTTP GET /readiness/status
     * Java method: no.eika.infrastruktur.jakarta.server.lib.HealthResource.readiness
     */
    readiness(options?: Headers): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`readiness/status`, copyFn: __identity<any>(), options: options });
    }
}

export interface LaanerammeWeb {
    aarsinntekt: number;
    antallBarn: number;
    antallBiler: number;
    antallLaantakere: number;
    gjeld: number;
    markedsrente: number;
    nedbetalingstid: number;
}

export interface MaksLaanerammeWeb {
    beloep?: number;
}

export interface RenteOgGebyrWeb {
    depotGebyr?: number;
    etableringsGebyr?: number;
    markedsrente?: number;
    terminGebyr?: number;
}

export type RestResponse<R> = Promise<R>;

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}

function __getCopyArrayFn<T>(itemCopyFn: (item: T) => T): (array: T[]) => T[] {
    return (array: T[]) => __copyArray(array, itemCopyFn);
}

function __copyArray<T>(array: T[], itemCopyFn: (item: T) => T): T[] {
    return array && array.map(item => item && itemCopyFn(item));
}

function __getCopyObjectFn<T>(itemCopyFn: (item: T) => T): (object: { [index: string]: T }) => { [index: string]: T } {
    return (object: { [index: string]: T }) => __copyObject(object, itemCopyFn);
}

function __copyObject<T>(object: { [index: string]: T }, itemCopyFn: (item: T) => T): { [index: string]: T } {
    if (!object) {
        return object;
    }
    const result: any = {};
    for (const key in object) {
        if (object.hasOwnProperty(key)) {
            const value = object[key];
            result[key] = value && itemCopyFn(value);
        }
    }
    return result;
}

function __identity<T>(): (value: T) => T {
    return value => value;
}
